.aspect {
    width: 100%;
    position: relative;
}

.aspect > * {
    width: 100%;
    height: 100%;
}
